import FullCalendar from '@fullcalendar/react';

import {
    TOGGLE_CALENDAR_MOUNT,
    UPDATE_CALENDAR_VIEW,
    useCalendar
} from '@/utils/hooks/scheduler/useCalendar';

export function useCalendarViewChange(ref: React.RefObject<FullCalendar>) {
    const { dispatchCalendar } = useCalendar();
    const handleViewChange = ({ value }) => {
        try {
            const calendarApi = ref.current?.getApi();
            if (!calendarApi) {
                // If we can't get calendar API, fallback to refresh
                dispatchCalendar({
                    type: TOGGLE_CALENDAR_MOUNT,
                    payload: value
                });
                return;
            }
            // Attempt direct view change first
            calendarApi.changeView(value);
            dispatchCalendar({
                type: UPDATE_CALENDAR_VIEW,
                payload: value
            });
        } catch (error) {
            console.warn('FullCalendar view change failed, forcing refresh', error);
            // Fallback: Force calendar refresh with new view
            dispatchCalendar({
                type: TOGGLE_CALENDAR_MOUNT,
                payload: value
            });
        }
    };
    return handleViewChange;
}
